import { useEffect, useState, useRef } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import "./css/Home.css";
import AdminNavbar from "../../component/AdminNavbar";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

export default function Home() {
  const { loginWithRedirect, user, isAuthenticated } = useAuth0();
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const chatMessagesRef = useRef(null); // Reference for message container
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null); // Selected chat user
  const [privateMessages, setPrivateMessages] = useState([]); // Private chat messages
  const [privateMessage, setPrivateMessage] = useState(""); // New message input

  useEffect(() => {
    if (isAuthenticated && user) {
      saveUserToDatabase(user);
    }
    fetchMessages();

    // Set interval to fetch messages every 5 seconds
    const interval = setInterval(fetchMessages, 5000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [isAuthenticated, user]);

  const saveUserToDatabase = async (user) => {
    try {
      await fetch("https://snapcourse.in/parishram/saveuser.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: user.email,
          name: user.name,
          profile_picture: user.picture,
        }),
      });
    } catch (error) {
      console.error("Error saving user:", error);
    }
  };

  const sendMessage = async () => {
    if (!message.trim()) return;

    try {
      const response = await fetch(
        "https://snapcourse.in/parishram/saveMessage.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: user.email,
            name: user.name,
            profile_picture: user.picture,
            message: message.trim(),
          }),
        }
      );
      const data = await response.json();
      if (data.success) {
        setMessage("");
        fetchMessages();
      }
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const deleteMessage = async (id, email) => {
    if (user.email !== email) return;

    try {
      const response = await fetch(
        "https://snapcourse.in/parishram/deleteMessage.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ messageId: id, email: user.email }),
        }
      );
      const data = await response.json();
      if (data.success) {
        fetchMessages();
      }
    } catch (error) {
      console.error("Error deleting message:", error);
    }
  };

  const fetchMessages = async () => {
    setLoading(true);
    try {
      const chatBox = chatMessagesRef.current;
      const isScrolledToBottom = chatBox
        ? chatBox.scrollHeight - chatBox.scrollTop === chatBox.clientHeight
        : false;

      const response = await fetch(
        "https://snapcourse.in/parishram/getMessages.php"
      );
      const data = await response.json();
      if (data.success) {
        setMessages(data.messages);
      }

      if (chatBox && isScrolledToBottom) {
        chatBox.scrollTop = chatBox.scrollHeight;
      }
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
    setLoading(false);
  };

  // Scroll to bottom on initial load
  useEffect(() => {
    if (chatMessagesRef.current) {
      chatMessagesRef.current.scrollTop = chatMessagesRef.current.scrollHeight;
    }
  }, [messages]);
  useEffect(() => {
    document.title = "Bakaiti Laboratory"; // Set the title for this page
  }, []);

  return (
    <>
      <AdminNavbar />
      <Navbar />
      {loading && <div className="loading">Loading messages...</div>}
      <div className="home-container">
        <div className="chat-box">
          <div className="chat-header">Public Chat Room</div>
          <div className="chat-messages" ref={chatMessagesRef}>
            {messages.map((msg) => (
              <div key={msg.id} className="message-container">
                <div className="message">
                  <img
                    src={msg.profile_picture}
                    alt="User"
                    className="user-pic"
                    referrerPolicy="no-referrer"
                  />
                  <div>
                    <span className="user">{msg.name}: </span> {msg.message}
                  </div>
                  {user?.email === msg.email && (
                    <button
                      className="delete-btn"
                      onClick={() => deleteMessage(msg.id, msg.email)}
                    >
                      Delete
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
          <div className="chat-input">
            {isAuthenticated ? (
              <>
                <input
                  type="text"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Type a message..."
                />
                <button onClick={sendMessage}>Send</button>
              </>
            ) : (
              <p className="info-text">Log in to send messages.</p>
            )}
          </div>
        </div>
        <div className="auth-box">
          {!isAuthenticated ? (
            <button className="login-btn" onClick={() => loginWithRedirect()}>
              Login to Chat
            </button>
          ) : (
            <p className="welcome-text">Welcome, {user.name}!</p>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}
